module.exports = __webpack_public_path__ + "static/media/1lg.0418a51a.jpg";